import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import '../Icon/components/index.js';
import { Icon } from '../Icon/Icon.js';
import keycode from 'keycode';
import '../../utils/hooks/useListKeyboardNavigation.js';
import '../Accordion/useAccordion.js';
import '../Accordion/Accordion.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Badge/Badge.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../IconButton/IconButton.js';
import '../Banner/Banner.js';
import '../Spinner/Spinner.js';
import '../Toast/Toaster.js';
import { useGaudiLocalization } from '../Provider/Provider.js';
import '../Calendar/Calendar.js';
import '../Checkbox/Checkbox.js';
import { Input } from '../Input/Input.js';
import '../../utils/hooks/useListScrollTo.js';
import '../Combobox/Combobox.js';
import '../../utils/date.js';
import '../Datepicker/Datepicker.js';
import '../Form/Form.js';
import '../Group/Group.js';
import '../Hanger/Hanger.js';
import '../Label/Label.js';
import '../Listbox/Listbox.js';
import '../Menu/Menu.js';
import '../Modal/Modal.js';
import '../Treeview/Treeview.js';
import '../Navigation/Navigation.js';
import '../Select/Select.js';
import '../Pagination/usePagination.js';
import '../Pagination/Pagination.js';
import '../Popover/Popover.js';
import '../Progress/Progress.js';
import '../RadioGroup/RadioGroup.js';
import '../Table/components/Table.js';
import '../Table/components/PaginatedTable.js';
import '../Table/components/WindowedTable.js';
import '../Table/util/rowIndexPath.js';
import '../Table/hooks/useRowCreation.js';
import '../Tabs/Tabs.js';
import '../Textarea/Textarea.js';
import '../Toggle/Toggle.js';
import '../Tour/Tour.js';
import '../../utils/hooks/useOnClickOutside.js';

var _excluded = ["onSearch"];
var SearchInput = /*#__PURE__*/forwardRef(function SearchInput(_ref, ref) {
  var onSearch = _ref.onSearch,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useGaudiLocalization = useGaudiLocalization(),
      texts = _useGaudiLocalization.texts;

  var handleSearchButtonClick = function handleSearchButtonClick() {
    if (!props.disabled) {
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(props.value);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    var isEnterKeyPressed = event.keyCode === keycode('enter');

    if (isEnterKeyPressed) {
      handleSearchButtonClick();
    }
  };

  return createElement(Input, Object.assign({
    className: "yt-search-input",
    "aria-label": texts.searchInput.inputLabel
  }, props, {
    ref: ref,
    onKeyDown: handleKeyDown,
    button: createElement("div", {
      className: "fake-button-wrapper",
      onClick: handleSearchButtonClick
    }, createElement(Icon, {
      name: "search"
    }))
  }));
});

export { SearchInput };
//# sourceMappingURL=SearchInput.js.map
